// RQ-148 (DEV-496): replace URL/storage-unsafe characters in an upload filename with underscore.
// This is a bespoke set (+ \ , * ? " < > | / :) that intentionally differs from the OS-illegal set
// targeted by the `sanitize-filename` package, which leaves the legal characters '+' and ',' intact.
// '/' and ':' are included because macOS translates a '/' typed in Finder into ':' at the POSIX
// layer, so the byte that reaches the browser/server is a colon — both must map to '_'.
const UNSAFE_UPLOAD_CHARS = /[+\\,*?"<>|/:]/g;

export const sanitizeUploadFileName = (name: string): string => (name ?? '').replace(UNSAFE_UPLOAD_CHARS, '_');
